<template>
  <div class="animated fadeIn pt-4 fab-container-bottom">
    <slot></slot>
    <b-row class="fab fab-bottom">
      <b-col>
        <b-button
          variant="dark"
          v-if="cancelButton"
          @click.prevent="$emit('cancel')">
          Annulla
        </b-button>
      </b-col>
      <b-col class="text-right">
        <b-button
          variant="danger"
          v-if="removeButton"
          @click.prevent="remove()">
          Elimina
        </b-button>
        <b-button
          variant="warning"
          v-if="editButton"
          @click.prevent="$emit('edit')">
          Modifica
        </b-button>
        <b-button
          variant="success"
          v-if="saveButton"
          @click.prevent="$emit('save')">
          Salva
        </b-button>
      </b-col>
    </b-row>
    <slot name="bottom"></slot>
    <slot name="debug"></slot>
  </div>
</template>
<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      default: () => undefined
    },

    cancelButton: {
      type: Boolean,
      default: false
    },

    removeButton: {
      type: Boolean,
      default: false
    },

    editButton: {
      type: Boolean,
      default: false
    },

    saveButton: {
      type: Boolean,
      default: false
    },

    removeConfirmMessage: {
      type: String,
      default: 'Vuoi veramente rimuovere questo elemento?'
    }
  },

  methods: {
    remove() {
      if (!confirm(this.removeConfirmMessage)) {
        return;
      }

      this.$emit('remove');
    }
  }
};
</script>
